
const digest = '7f64a37631a31634c75d2418cacc982730f3b2d7b4b63cd56fa597baf3e5f20b';
const classes = {"collapse":"_collapse_ufi0c_1","emptyTitle":"_emptyTitle_ufi0c_5"};
const css = `._collapse_ufi0c_1 {
  overflow-x: hidden;
}

._emptyTitle_ufi0c_5 {
  font-size: 14px;
  font-weight: 500;
  background: #fff;
  padding: 26px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  